import { Text, View } from "@react-pdf/renderer";
import {
  convertDateFormat,
  convertOnlyDateFormat,
  formatMidasNumber,
} from "../../../global";
import { styles } from "./PrintStylesheet";
import { WORK_REQUEST_TYPES_ENUM } from "./constants";

export default function PrintShippingRequest({ workRequestSamples, shippingRequest, shippingAddress, dotHazardClass, workRequest }) {
  const nonChemicalItems = shippingRequest?.shippingItems.filter((i) => !i.sampleName && !!i.description) ?? [];
  const wrSamples = workRequestSamples?.filter((item) => !!item.sample) ?? [];
  const legendText = "For 24-Hour Emergency Response, call ChemTrec\nDomestic calls inside US, 1-800-424-9300\nInternational calls outside US, 1-703-527-3887\nfor ExxonMobil Technology & Engineering Company"
  const isSiteToSiteTransport = workRequest.typeName === WORK_REQUEST_TYPES_ENUM.EXXON_MOBIL_SITE_TO_SITE_TRANSPORT;

  return (
    <View>
      <Text style={styles.subtitle}>Shipping Information</Text>
      <View style={styles.tableDivider} />
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item50]}>
            Request Id#
          </Text>
          <Text style={[styles.tableText, styles.item50]}>
            {workRequest?.id}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item50]}>
            Priority
          </Text>
          <Text style={[styles.tableText, styles.item50]}>
            {workRequest.priorityName}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item50]}>
            Request Description
          </Text>
          <Text style={[styles.tableText, styles.item50]}>
            {workRequest.description}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item50]}>
            Requester E-mail
          </Text>
          <Text style={[styles.tableText, styles.item50]}>
            {workRequest.requestedByEmail}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item50]}>
            Requested Date
          </Text>
          <Text style={[styles.tableText, styles.item50]}>{convertDateFormat(workRequest.createdDate)}</Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item50]}>
            Required Completion Date
          </Text>
          <Text style={[styles.tableText, styles.item50]}>{convertOnlyDateFormat(workRequest.requestedCompletionDate)}</Text>
        </View>        
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item50]}>
            Comments
          </Text>
          <Text style={[styles.tableText, styles.item50]}>
            {workRequest.comments}
          </Text>
        </View>
      </View>
      <View style={styles.tableDivider} />
      <Text style={styles.subtitle}>Recipient Information</Text>
      <View style={styles.tableDivider} />
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item50]}>
            Recipient's Name: 
          </Text>
          <Text style={[styles.tableText, styles.item50]}>
            {shippingAddress?.recipientName}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item25]}>
          Recipient's Email
          </Text>
          <Text style={[styles.tableText, styles.item25]}>
            {shippingAddress?.emailAddress}
          </Text>
          <Text style={[styles.tableText, styles.item25]}>
          Phone #
          </Text>
          <Text style={[styles.tableText, styles.item25]}>
            {shippingAddress?.phoneNumber1}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item50]}>
            {isSiteToSiteTransport ? "Room/Lab" : "Company"}
          </Text>
          <Text style={[styles.tableText, styles.item50]}>
            {shippingAddress?.company}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item50]}>
            Street Address
          </Text>
          <Text style={[styles.tableText, styles.item50]}>
            {shippingAddress?.address1}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item50]}>
            Department/Floor No
          </Text>
          <Text style={[styles.tableText, styles.item50]}>
            {shippingAddress?.department}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={[styles.tableText, styles.item165]}>
            City, State
          </Text>
          <Text style={[styles.tableText, styles.item165]}>
            {shippingAddress?.city}, {shippingAddress?.state}
          </Text>
          <Text style={[styles.tableText, styles.item165]}>
            Zip
          </Text>
          <Text style={[styles.tableText, styles.item165]}>
            {shippingAddress?.postalCode}
          </Text>
          <Text style={[styles.tableText, styles.item165]}>
            Country
          </Text>
          <Text style={[styles.tableText, styles.item165]}>
            {shippingAddress?.country}
          </Text>
        </View>
      </View>
      <Text style={styles.legend}>
            {legendText}
      </Text>
        <View>
          <Text style={styles.subtitle}>MIDAS Sample Information</Text>
          <View style={styles.tableDivider} />
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text style={[styles.tableText, styles.item10]}>MIDAS #</Text>
              <Text style={[styles.tableText, styles.item10]}>Container #</Text>
              <Text style={[styles.tableText, styles.item10]}>Size (& UoM)</Text>
              <Text style={[styles.tableText, styles.item70]}>Description</Text>
            </View>
            {wrSamples.map((item, index) => {
              const container = item.newContainer ?? item.existingContainer ?? null;

              return (<View style={styles.tableRow} wrap={false} key={`sample-row-${index}`}>
                <Text style={[styles.tableText, styles.item10]}>
                  {item?.sample?.sampleName
                    ? formatMidasNumber(item?.sample?.sampleName)
                    : "-"}
                </Text>
                <Text style={[styles.tableText, styles.item10]}>
                  {item && (container?.containerNumber || container?.containerNumber === 0) ? container?.containerNumber : "Any"}
                </Text>
                <Text style={[styles.tableText, styles.item10]}>
                  {container ? `${container?.size ?? ''} ${container?.containerSizeUoM ?? ''}` : item ? `${item?.requestedAmount ?? ''} ${item?.requestedAmountUoM ?? ''}` : ""}
                </Text>
                <Text style={[styles.tableText, styles.item70]}>
                  {item?.blindCodeDescription ?? item?.sample?.description}
                </Text>
              </View>
              )
            }
            )}
          </View>
        </View>
        <View>
          <Text style={styles.subtitle}>Non-chemical Item Information</Text>
          <View style={styles.tableDivider} />
          <View style={styles.table}>
            <View style={styles.tableRow}>              
              <Text style={[styles.tableText, styles.item20]}>
                Quantity
              </Text>
              <Text style={[styles.tableText, styles.item80]}>
                Description
              </Text>
            </View>
            {nonChemicalItems?.map((x, index) => (
              <View style={styles.tableRow} wrap={false} key={`non-chemical-row-${index}`}>                
                <Text style={[styles.tableText, styles.item20]}>
                  {x.quantity}
                </Text>
                <Text style={[styles.tableText, styles.item80]}>
                  {x.description}
                </Text>
              </View>
            ))}
          </View>
        </View>
    </View>
  );
}
